import React from 'react'
import Link from 'gatsby-link'

const Footer = () => (
  <div className="Footer">
    <div className="Footer__link">
      {/*
      <Link to="/help">ヘルプ</Link>
      */}
      <Link to="/term-of-use">利用規約</Link>
      <Link to="/privacy-policy">プライバシーポリシー</Link>
    </div>
    <div className="Footer__copyright">
      <a href="http://saib-stud.io" target="_blank">Copyright © 2018 Saib Studio LLC. All Rights Reserved.</a>
    </div>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js